import { PersonaCommunity } from "../../stores/types/personasTypes";

interface EnrichedPersonaCheck {
  is_ai_generated: boolean;
  affinity_strength?: string | number | null;
  total_size?: number;
  communities?: PersonaCommunity[];
  updated_at?: string;
}

export const isPersonaEnriching = (persona: EnrichedPersonaCheck): boolean => {
  if (persona.is_ai_generated) {
    return false;
  }

  const hasMissingData =
    !persona.affinity_strength ||
    !persona.total_size ||
    !persona.communities ||
    persona.communities.length === 0;

  if (!hasMissingData) {
    return false;
  }

  if (!persona.updated_at) {
    return false;
  }

  const updatedAt = new Date(persona.updated_at).getTime();
  const tenMinutesAgo = Date.now() - 10 * 60 * 1000;

  return updatedAt > tenMinutesAgo;
};
